import React, { useCallback, useRef } from 'react';
import { Form } from 'antd';
import { debounce } from 'lodash';
import { I18n } from '@aws-amplify/core';
import InputNumber from '@/components/ui/InputNumber';
import { FormItemWrapper } from '@/components/views/Report/KimLhc/Components/Form/Fields/FormItemWrapper';
import type { Rule } from 'antd/es/form';

interface LoadWeightFormItemProps {
	fieldName?: string | string[];
	required?: boolean;
}

const DEBOUNCE_MS = 1000;

const { useFormInstance } = Form;

export function LoadWeightFormItem({ required = true, fieldName }: Readonly<LoadWeightFormItemProps>): JSX.Element {
	const form = useFormInstance();

	const rule: Rule = {
		validator: (_, value) => {
			if (value > 0) {
				return Promise.resolve();
			}
			return Promise.reject(new Error(I18n.get('The field requires an answer')));
		}
	};

	const rules: Rule[] = required ? [rule] : [];

	const handleOnChange = useRef(
		debounce((value: number | null) => {
			if (fieldName) {
				form.setFieldValue(fieldName, value);
			}
		}, DEBOUNCE_MS)
	);

	const onChange = useCallback((value: number | string | null) => {
		const numValue = typeof value === 'string' ? parseFloat(value) : value;
		handleOnChange.current(numValue);
	}, []);

	return (
		<FormItemWrapper name={fieldName} required={required} rules={rules}>
			<InputNumber placeholder="20kg" min={0} addonAfter="kg" onChange={onChange} />
		</FormItemWrapper>
	);
}
